const SLOT_LABELS = {
  '9-12': '9:00 AM - 12:00 PM',
  '12-3': '12:00 PM - 3:00 PM',
  '3-6': '3:00 PM - 6:00 PM',
  '6-9': '6:00 PM - 9:00 PM',
};

export function formatDeliveryTime(delivery) {
  if (!delivery) return '';
  if (delivery.timeLabel) return delivery.timeLabel;
  return SLOT_LABELS[delivery.time] || delivery.time || '';
}

export function formatEstimatedArrival(isoString) {
  if (!isoString) return null;
  return new Date(isoString).toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
